<template>
    <div id="picture-capture">


        <Spinner v-if="loadingAllImages" v-bind:title="'Loading Pictures ...'|trans"  ></Spinner>

        <ul class="full-width no-padding content-images">
            <li v-for="(picture, index) in pictures" class="pull-left image-thumb">
                <i class="fa fa-spinner fa-spin delete_loader" style="font-size:24px"
                   v-if="picture.deletedInProgress"></i>
                <span class="fa fa-check selected-icon" v-show="picture.is_selected"></span>
                <div class="content-image" @click="picture.is_selected = !picture.is_selected; emitPicturesSelected()">
                    <img v-bind:src="absolutePath(picture.filename)" height="auto" width="100%"/>
                </div>
                <button class="btn btn-default full-width delete-btn" @click="deletePicture(index, picture); "
                        :disabled="picture.deletedInProgress === true">
                    <i class="fa fa-trash"></i>
                </button>
            </li>
        </ul>

        <div class="row " v-show="pictures.length > 0 || isUploading">
            <div class="col-xs-12 text-center">

                <input type="file" @change="onFileChanged" class="hidden" v-bind:id="_uid"
                       accept="image/png,image/jpeg,image/jpg,image/gif" >

                <div id="upload-picture" v-show="isUploading">
                    <strong>{{'Uploading Picture Please Wait'|trans}} </strong>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                             v-bind:style="{width:+uploadPercentage+'%'}"
                        >
                            <span>{{uploadPercentage}}%</span>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button  class="btn btn-primary full-width" v-show="!isUploading" v-if="canTakePicture">
            <label v-bind:for="_uid" class="full-width">
                {{'Take a picture'|trans}}
                <i class="fa fa-camera fa-1x" aria-hidden="true"></i>
            </label>
        </button>
    </div>
</template>

<script>
    import Compressor from 'compressorjs';
    import Spinner from './Spinner';

    export default {
        name: 'app',
        props: {
            jobid: Number,
            documentID: Number,
            tagPicture: null,
            multiplePictures: true,
            selectedPictures: []
        },
        data() {
            return {
                pictures: [],
                canTakePicture: true,
                loadingAllImages: false,
                uploadPercentage: 0,
                isUploading: false,
                myID: null
            }
        },
        created() {
            this.getAllPictures();
        },
        methods: {
            async deletePicture(index, picture) {
                this.pictures[index].deletedInProgress = true;
                const response = await this.$api.picture.deletePicture(picture.id);
                if (response.has_error === false) {
                    this.pictures.splice(index, 1);
                } else {
                    alert('Cannot delete this image because is used for this document');
                    this.pictures[index].deletedInProgress = false;
                }
            },
            async onUpload() {
                this.isUploading = true;
                new Compressor(
                    this.selectedFile,
                    {
                        maxWidth: 960,
                        quality: 0.5,
                        success: async compressedFile => {

                            const formData = new FormData();
                            formData.append('file', compressedFile, compressedFile.name);

                            formData.append('workerinterfacebundle_picture[filename]', compressedFile, compressedFile.name);

                            let localTagPicture = this.tagPicture;
                            if (localTagPicture == null) {
                                localTagPicture = 'global';
                            }

                            formData.append('workerinterfacebundle_picture[tag]', localTagPicture);
                            const responseData = await  this.$api.picture.newPicture(
                                this.jobid,
                                formData,
                                progressEvent => {
                                    this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                                }
                            );

                            this.loadingAllImages = false;
                            let fileResponse = responseData;
                            let picture = {filename: fileResponse.filename, id: fileResponse.id, is_selected: true}
                            this.pictures.unshift(picture);
                            this.emitPicturesSelected();
                            this.uploadPercentage = 0;
                            this.isUploading = false;

                        },
                        error(err) {
                            console.log(err.message);
                        }
                    }
                );
            },
            async getAllPictures() {
                if (this.documentID !== undefined) {
                    this.loadingAllImages = true;
                    const responseData = await this.$api.picture.getPicturesOfJobAndDocument(this.documentID, this.tagPicture);
                    this.loadingAllImages = false;
                    this.pictures = responseData.pictures.map(
                        function (picture) {
                            picture.deletedInProgress = false;
                            picture.is_saving = false;
                            if (picture.is_selected === undefined) {
                                picture.is_selected = false;
                            }

                            return picture;
                        }
                    );
                }
            },
            emitPicturesSelected() {

                let picturesSelected = this.pictures.filter(picture => {
                    return picture.is_selected === true
                });

                this.$emit('picturesSelected', picturesSelected);
            },
            onFileChanged(event) {
                this.selectedFile = event.target.files[0]
                this.onUpload();
            },
            absolutePath(image) {
                return process.env.VUE_APP_API_BASE_URL_ASSETS + "/uploads/job_pictures/" + "sm-" + image;
            }
        },
        watch: {
            pictures: {
                handler: function (newpictures) {
                    if (newpictures.length >= 1 && this.multiplePictures === false) {
                        this.canTakePicture = false
                    } else {
                        this.canTakePicture = true
                    }
                    this.$emit('numberOfPictures:changed', this.pictures.length);
                },
                deep: true
            }
        },
        components: {
            Spinner
        }

    }
</script>

<style scoped>

    #picture-capture .content-image {
        height: 80px;
        overflow: hidden;
        background-color: gray;
    }

    #picture-capture .selected-icon {
        position: absolute;
        right: 0px;
        padding: 1px;
        margin: 4px;
        color: white;
        background: #8BC34A;
        border-radius: 8px;
        border: 1px solid #ececec;
    }

    #picture-capture {
        width: 100%;
    }

    #picture-capture ul li {
        display: inline;
        /*padding: 5px;*/
        width: 23%;
        margin:1%;
    }

    #picture-capture ul .image-thumb {
        position: relative;
    }

    #picture-capture ul .delete_loader {
        position: absolute;
        left: 35%;
        top: 14%;
        color: #101010;
        text-shadow: 2px 1px 7px white;
    }

    #picture-capture ul .delete-btn {
        min-height: 30px;
        margin: 0px;
    }

    #picture-capture #upload-photo {
        display: none;
    }

    .flat-blue .progress .progress-bar {
        background-color: #22A7F0;
        border-radius: 9px;
        background-color: #0ae;
        background-image: -webkit-gradient(linear, 0 0, 0 100%, color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.5, transparent), to(transparent));
        background-image: -moz-linear-gradient(rgba(255, 255, 255, .2) 50%, transparent 50%, transparent);
        background-image: -o-linear-gradient(rgba(255, 255, 255, .2) 50%, transparent 50%, transparent);
        background-image: linear-gradient(rgba(255, 255, 255, .2) 50%, transparent 50%, transparent);
    }

    .flat-blue .progress .progress-bar span {
        color: white;
        font-weight: bold;
    }
</style>